import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import Highcharts from 'highcharts';
import Chart from '../../Chart';
import {truncateText} from '../../../utils/analytics';

class FullscreenChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fullscreen: !!document.fullscreenElement,
        };
        this.containerRef = React.createRef();
        this.handleFullscreen = this.handleFullscreen.bind(this);
        this.customLabel = null;
        this.maxLabel = null;
    }

    getNormalOptions(originalOptions) {
        const options = cloneDeep(originalOptions);
        if (!this.props.hints || !this.props.hints.printable) {
            // Truncate only if not printable
            options.title.text = truncateText(originalOptions.title.text);
        }
        return options;
    }

    getFullscreenOptions(originalOptions) {
        const options = cloneDeep(originalOptions);
        options.exporting.buttons.contextButton.menuItems = originalOptions.exporting.buttons.contextButton.menuItems.filter((x) => x !== 'viewFullscreen');
        return options;
    }

    getOptions(options) {
        const newOptions = this.state.fullscreen ? this.getFullscreenOptions(options) : this.getNormalOptions(options);
        if (!this.customLabel) {
            const self = this;
            set(newOptions, 'chart.events.load', function() {
                // eslint-disable-next-line no-invalid-this
                self.customLabel = this.renderer.label(self.props.customLabel).css({color: '#343940'}).add();
                self.customLabel.align(Highcharts.extend(self.customLabel.getBBox(), {
                    align: 'center',
                    verticalAlign: 'bottom',
                    x: 0,
                    y: 30,
                }), null, 'spacingBox');
                // eslint-disable-next-line no-invalid-this
                self.maxLabel = this.renderer.label(self.props.maxLabel).css({color: '#343940'}).add();
                self.maxLabel.align(Highcharts.extend(self.maxLabel.getBBox(), {
                    align: 'left',
                    verticalAlign: 'bottom',
                    x: 0,
                    y: 30,
                }), null, 'spacingBox');
            });
        }
        return newOptions;
    }

    handleFullscreen() {
        const isFullscreen = !!document.fullscreenElement;
        if (isFullscreen) {
            // check if is fullscreenElement is descendant of current ref
            if (this.containerRef.current) {
                if (this.containerRef.current.contains(document.fullscreenElement)) {
                    this.setState({
                        fullscreen: true,
                    });
                }
            }
        } else {
            if (this.state.fullscreen) {
                this.setState({
                    fullscreen: false,
                });
            }
        }
    }

    componentDidMount() {
        document.addEventListener('fullscreenchange', this.handleFullscreen);
    }

    componentWillUnmount() {
        document.removeEventListener('fullscreenchange', this.handleFullscreen);
    }

    render() {
        const {options, customLabel, maxLabel, ...rest} = this.props;
        if (this.customLabel) {
            this.customLabel.attr({text: customLabel});
        }
        if (this.maxLabel) {
            this.maxLabel.attr({text: maxLabel});
        }
        return (
            <Chart ref={this.containerRef} options={this.getOptions(options)} {...rest} />
        );
    }
}

export default FullscreenChart;
